import styled, { css } from 'styled-components';
import SendIcon from 'images/sports/common/message_send.svg';
import SendOnIcon from 'images/sports/common/message_send_on.svg';
import CheerIcon from 'images/sports/common/ic-cheers-w.svg';
import UploadIcon from 'images/sports/common/ic-upload.svg';
import UploadLoading from 'images/sports/common/upload-loading.svg';
import UploadDeleteIcon from 'images/sports/common/ic-delete-upload.svg';
import CloseWhite from 'images/common-function/close-white.png';
import PowerChatIcon from 'images/sports/common/ic-power-chat.png';
import RealIcon from 'images/sports/common/ic-real.svg';
import FakeIcon from 'images/sports/common/ic-fake.svg';
import OddsUp from 'images/sports/common/ic-odds-up.png';
import OddsDown from 'images/sports/common/ic-odds-down.png';
import AllOnIcon from 'images/sports/common/ic-cheer-all-on.svg';
import AllOffIcon from 'images/sports/common/ic-cheer-all-off.svg';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Nav = styled.div`
  padding: 0 20px;
  height: 50px;
  background: #454545;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  letter-spacing: -1px;
  color: #fff;
`;

export const CheerCount = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 11px;
  font-family: Verdana, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0;
  padding-bottom: 1px;
  &:before {
    content: '';
    display: block;
    background: url(${CheerIcon}) no-repeat center center;
    background-size: 11px;
    width: 11px;
    height: 10px;
    margin-right: 6px;
  }
`;

export const Wrapper = styled.div`
  height: calc(100% - 51px);
  border: 1px solid #e0e0e0;
  border-top: none;
  border-left: none;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const InputWrapper = styled.div`
  min-height: 82px;
  max-height: 82px;
  background: #f8f8f8;
  padding: 15px;
  border-top: 1px solid #e0e0e0;
  position: relative;
`;

export const InputButtonWrap = styled.div`
  width: 100%;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .img_upload {
    > input {
      display: none;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    cursor: pointer;
    border: 1px solid #e0e0e0;
    padding: 0 21px;
    background: #fff;
    border-radius: 15px;
    :before {
      content: '';
      display: inline-block;
      width: 18px;
      height: 15px;
      background: url(${UploadIcon}) no-repeat center center;
      background-size: 18px 15px;
      margin-right: 8px;
    }
    > span {
      margin-top: 2px;
    }
    :hover {
      text-decoration: underline;
    }
  }
`;

export const InputForm = styled.form`
  margin-top: 10px;
  width: 100%;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Label = styled.label`
  height: 100%;
  display: inline-block;
  flex: 1;
`;
export const Input = styled.input`
  height: 100%;
  width: 100%;
  background: #fff;
  text-indent: 20px;
  letter-spacing: -1px;
  &::placeholder {
    color: #aaa;
  }
  border-radius: 20px;
  border: 1px solid #e0e0e0;
`;

export const SubmitButton = styled.button`
  display: inline-block;
  border: none;
  margin-left: 5px;
  height: 100%;
  width: 40px;
  ${(props) =>
    props.isActive
      ? css`
          background: url(${SendOnIcon}) no-repeat center center;
        `
      : css`
          background: url(${SendIcon}) no-repeat center center;
        `}
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    //display: none;
  }
`;

export const List = styled.ul`
  padding: 20px 20px 0;
  width: 100%;
  box-sizing: border-box;
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 20px;
  }
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  &:not(:first-child) {
    margin-top: 15px;
  }
`;

export const UserRow = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${(props) =>
    (props.isMe || props.isChamp) &&
    css`
      cursor: initial;
    `};
  > span {
    margin-right: 8px;
    font-size: 12px;
    font-weight: 600;
    ${(props) =>
      props.isMe &&
      css`
        color: #ed2026;
      `}
    &.analysis {
      color: #f09a3d !important;
      font-weight: bold;
      margin-right: 3px;
    }
  }
  .profile {
    width: 19px;
    height: 19px;
    margin-right: 6px;
    border-radius: 50%;
  }
  > em {
    width: 19px;
    height: 19px;
    &.r {
      background: url(${RealIcon}) no-repeat center center;
      background-size: 19px;
    }
    &.f {
      background: url(${FakeIcon}) no-repeat center center;
      background-size: 19px;
    }
  }

  .champ {
    margin-right: 4px;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  margin-top: 8px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  max-width: 100%;
`;

export const ParentContent = styled.div`
  background-color: #f8f8f8;
  padding: 10px 15px 5px;
  display: flex;
  align-items: center;
  color: #333;
  cursor: pointer;
  > span {
    margin-right: 6px;
    font-weight: bold;
  }
  .comment_content {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
    > img {
      width: 20px;
      height: 20px;
      min-width: 20px;
      margin-right: 4px;
    }
    > p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }
`;

export const Content = styled.div`
  background: #f3f4f8;
  padding: 10px 15px;
  border-radius: 0 15px 15px;
  max-width: 100%;
  word-break: break-all;
  line-height: 18px;
  overflow: hidden;
  a {
    color: #2386da;
    margin-left: 4px;
    font-weight: normal !important;
    &.game_score {
      text-decoration: underline;
      margin: 0 0 2px 0;
      font-size: 11px;
      display: block;
      width: 100%;
    }
  }
  > img {
    width: 30px;
    height: 30px;
    margin-right: 11px;
    cursor: pointer;
  }
  > em {
    :before {
      content: '';
      width: 9px;
      height: 9px;
      margin-right: 3px;
      display: inline-block;
    }
    &.up {
      :before {
        background: url(${OddsUp}) no-repeat center center;
        background-size: 9px;
      }
    }
    &.down {
      :before {
        background: url(${OddsDown}) no-repeat center center;
        background-size: 9px;
      }
    }
  }
  ${(props) =>
    props.isMe &&
    css`
      color: #ed2026;
    `}
  ${(props) =>
    props.type === 'caster' &&
    css`
      background-color: #e8f7f4;
    `}
  ${(props) =>
    props.type === 'event' &&
    css`
      background-color: #e3edff;
    `}
  ${(props) =>
    props.isImportImg &&
    css`
      display: flex;
    `}
  ${(props) =>
    props.differentGame &&
    css`
      flex-wrap: wrap;
    `}
  &.m, &.b, &.f {
    opacity: 0.3;
  }

  ${(props) =>
    props.isComment &&
    css`
      padding: 0;
      max-width: calc(100% - 30px);
      > .content {
        padding: 5px 15px 10px;
      }
    `}

  ${(props) =>
    props.animate &&
    css`
      animation: up-down 1s 1;
    `}
  ${(props) =>
    props.isChamp &&
    css`
      background-color: #f5c917;
      .content {
        font-weight: bold;
      }
    `}
  
  @keyframes up-down {
    0% {
      transform: none;
    }
    10% {
      transform: translateY(-7px);
    }
    20% {
      transform: translateY(0);
    }
    30% {
      transform: translateY(-5px);
    }
    40% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-2px);
    }
    60% {
      transform: translateY(0px);
    }
    100% {
      transform: none;
    }
  }
`;

export const ContentWriteTime = styled.span`
  font-family: Tahoma, -apple-system, SF Pro Display, Helvetica Neue, sans-serif;
  margin-left: 5px;
  padding-bottom: 10px;
  font-size: 9px;
  color: #ccc;
`;

export const UploadImageWrap = styled.div`
  position: absolute;
  top: -90px;
  left: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  transition: opacity 0.2s ease, transform 0.2s ease;
  will-change: opacity, transform;
  ${(props) =>
    props.isActive
      ? css`
          opacity: 1;
          transform: translateY(0);
        `
      : css`
          opacity: 0;
          transform: translateY(10px);
          visibility: hidden;
        `}
`;

export const PreviewImage = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 5px;
  background: url(${(props) => props.imageUrl}) no-repeat center center;
  background-size: contain;
  z-index: 1;
`;

export const PreviewLoading = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 8px;
  margin: -4px 0 0 -16px;
  background: url(${UploadLoading}) no-repeat 0 0;
  background-size: 36px 8px;
  color: transparent;
`;

export const PreviewImageCancel = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 22px;
  height: 22px;
  background: url(${UploadDeleteIcon}) no-repeat center center;
  background-size: 22px 22px;
  z-index: 2;
  cursor: pointer;
`;

export const ImageViewBackground = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.75);
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.isScroll &&
    css`
      align-items: flex-start;
    `}
  img {
    max-width: 80%;
    height: fit-content;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  :before {
    content: '';
    display: flex;
    width: 60px;
    height: 60px;
    background: url(${CloseWhite}) no-repeat center center;
    background-size: 30px;
  }
`;

export const PowerChatButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  padding: 0 21px;
  background: #fff;
  color: #fb307e;
  border-radius: 15px;
  margin-left: 6px;
  > span {
    margin-top: 2px;
  }
  :before {
    content: '';
    display: inline-block;
    width: 18px;
    height: 15px;
    background: url(${PowerChatIcon}) no-repeat center center;
    background-size: 18px 15px;
    margin-right: 8px;
  }
`;

export const CasterChatButton = styled.button`
  height: 30px;
  padding: 0 10px;
  border: 1px solid #e0e0e0;
  border-radius: 15px;
  background-color: #fff;
  margin-left: auto;
  ${(props) =>
    props.isActive &&
    css`
      background-color: #3db39e;
      color: #fff;
    `}
`;

export const AllButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  position: absolute;
  right: 20px;
  bottom: 140px;
  :before {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    background: url(${(props) => (props.active ? AllOffIcon : AllOnIcon)})
      no-repeat center center;
    background-size: 22px 15px;
  }
`;
